import Common from './common'

let routes = [...Common];

export default routes;
